import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import "./Footer.css";
import ReactDOM from "react-dom";
import { DonationImage } from "../donations";
import { changelog, showChangeLog } from "./Changelog";
import React from "react";
import { Translations, useTranslations } from "../i18n";
import { ExportModal } from "../export/ExportModal";
import { Imprint } from "./imprint/Imprint";
import { useLocation } from "wouter";

export function Footer() {
    const t = useTranslations();

    return <>
        <div className="footer-wrapper">
            <footer>
                <ModalLink target="how-to">{t.howTo}</ModalLink> ·
                <ModalLink target="changelog">{t.whatsNew}</ModalLink> ·
                <ModalLink target="data-privacy">{t.dataPrivacy}</ModalLink> ·
                <ModalLink target="imprint">{t.imprint}</ModalLink>
            </footer>
        </div>
        <Modals />
    </>
}

function ModalLink(props: { target: keyof typeof modalTexts, children?: React.ReactNode }) {
    const { target, children } = props;
    const [_location] = useLocation();
    const targetLink = new URL(_location, window.location.origin);
    targetLink.pathname = `/${target}`;

    return <a href={"#" + targetLink.toString().substring(window.location.origin.length)}>
        {children}
    </a>;

}

function Modals() {
    return ReactDOM.createPortal(<>
        <Modal id="changelog" activeByDefault={showChangeLog} />
        <Modal id="how-to" />
        <Modal id="data-privacy" />
        <Modal id="imprint" />
        <Modal id="export" />
    </>, document.getElementById("modal-container")!);
}

const modalTexts = {
    "how-to": (t: Translations) => <>
        <h1>{t.howTo}</h1>
        {t.howToText}

        <br />
        <br />
        <br />

        {t.donationInfo}

        <br /><br />

        <DonationImage />

        <br />

        {t.improvementInfo}

        <br /><br />

        <ModalLink target="imprint" >{t.contactSeeImprint}</ModalLink>
    </>,
    "imprint": (t: Translations) => <>
        <h1>{t.imprint}</h1>

        <Imprint />
    </>,
    "data-privacy": (t: Translations) => <>
        <h1>{t.dataPrivacy}</h1>
        {t.dataPrivacyContent}
    </>,
    "changelog": changelog,
    "export": () => <ExportModal />
}

function Modal(props: { id: keyof typeof modalTexts, activeByDefault?: boolean }) {
    const { id, activeByDefault } = props;
    const [_location] = useLocation();
    const location = new URL(_location, window.location.origin);

    const pathname = `/${id}`;
    const isActive = location.pathname === pathname;
    const [wasActivated, setWasActivated] = React.useState(false);
    const t = useTranslations();

    React.useEffect(() => {
        if (activeByDefault && location.pathname === "/" && !wasActivated) {
            window.location.hash = "#" + id + location.search
            setWasActivated(true);
        }
    }, [activeByDefault, id, location.search, location.pathname, wasActivated, setWasActivated]);

    return <div
        className={classNames("modal", id, { isActive })}
        onClick={e => {
            if (e.target === e.currentTarget)
                window.location.hash = "#" + location.search
        }}
    >
        <div className="modal-inner">
            <div className="icon-button modal-close-button" onClick={() => window.location.hash = "#" + location.search}>
                <FontAwesomeIcon icon={faTimes} />
            </div>
            {modalTexts[id](t)}
        </div>
    </div>
}
